/**
 * rebalance.js — 델타전략 리밸런싱 산식 (DAS-175).
 *
 * 목표 Risky 잔액은 **보유 BTC 현물을 제외한 잔액**의 25%다 (DAS-172).
 * 보유 BTC는 적립분이라 이동 대상이 아니므로 총액에 포함하면 목표와 이동액이 부풀려진다.
 * total_info_description / total_balance_exchange_rate_base가 각자 복사해 쓰던 식을 한곳으로 모았다.
 */

export const REQUIRED_RISKY_RATIO = 0.25;

/**
 * @param {Object} args
 * @param {number} args.totalBalance      코인 총 잔액(KRW, BTC 포함 실보유)
 * @param {number} args.totalFiatBalance  Fiat 잔액(KRW, BTC 포함 실보유)
 * @param {number} args.totalRiskyBalance Risky 잔액(KRW 환산)
 * @param {number} args.btcSpotBalance    보유 BTC 현물 평가액(KRW)
 * @returns {{heldBtcValue: number, base: number, deltaFiatBalance: number,
 *            requiredRisky: number, sendBalance: number, receiveExchange: "Fiat"|"Risky"}}
 */
export function computeRebalance({ totalBalance, totalFiatBalance, totalRiskyBalance, btcSpotBalance }) {
    const heldBtcValue = Math.max(0, Number(btcSpotBalance) || 0);
    const base = Math.max(0, (Number(totalBalance) || 0) - heldBtcValue);
    const risky = Number(totalRiskyBalance) || 0;
    const deltaFiatBalance = (Number(totalFiatBalance) || 0) - heldBtcValue;
    const requiredRisky = base * REQUIRED_RISKY_RATIO;
    return {
        heldBtcValue,
        base,
        deltaFiatBalance,
        requiredRisky,
        sendBalance: Math.abs(requiredRisky - risky),
        receiveExchange: base - requiredRisky < deltaFiatBalance ? "Risky" : "Fiat",
    };
}
